<template>
  <section class="section-forgot">
    <img
      class="trebel-logo-redesign only-desk"
      :src="`${publicPath}assets/images/trebel_logo.png`"
      :alt="$t('TREBEL')"
    />
    <div class="container">
      <b-img
        class="backButton"
        :src="`${publicPath}assets/images/backbutton.png`"
        alt="Go Back"
        @click="$router.back()"
      ></b-img>
      <div class="section-forgot-inner mt-56 mb-40">
        <form @submit.prevent="forgotPassword">
          <h3
            :class="
              $route.query.type === 'walmart'
                ? 'forgot-title forgot-email-text-black'
                : 'forgot-title'
            "
          >
            {{ $t("trubleLoggingIn") }}
          </h3>
          <p
            :class="
              $route.query.type === 'walmart'
                ? 'forgot-email-text forgot-email-text-black'
                : 'forgot-email-text'
            "
          >
            {{ $t("forgotEmailText") }}
          </p>
          <div class="form-control-icon-wrap">
            <div class="input-field-floating">
              <b-form-input
                v-model="credentials.email"
                placeholder=""
                name="email"
                data-vv-as="Email"
                autocapitalize="off"
                @input="checkValidation()"
                :class="{
                  'error-input': errors.has('email'),
                  'valid-input': !errors.has('email') && credentials.email
                }"
              ></b-form-input>
              <label> {{ $t("email") }}</label>
              <img
                v-if="credentials.email && credentials.email.length"
                class="delete-inputed"
                :src="`${publicPath}assets/images/svg/delete.svg`"
                alt="delete"
                @click="credentials.email = null"
              />
            </div>
            <div v-if="errors.has('email')" class="invalid-field">
              {{ errors.first("email") }}
            </div>
            <div v-if="error.message" class="invalid-field">
              {{ error.message }}
            </div>
          </div>
          <b-button
            type="submit"
            variant="yellow"
            class="btn-login mt-177"
            :disabled="!checkValidation()"
            block
            >{{ $t("continue") }}</b-button
          >
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      credentials: {
        email: null
      },
      error: {
        message: ""
      },
      btnClass: "",
      // eslint-disable-next-line no-control-regex
      regex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    };
  },
  methods: {
    checkValidation() {
      return this.regex.test(this.credentials.email);
    },
    forgotPassword() {
      const validEmail = this.regex.test(this.credentials.email);
      if (!validEmail) {
        return;
      }
      this.$store
        .dispatch("forgotPassword", this.credentials)
        .then(() => {
          this.$router.push({
            name: "Success",
            query: { type: "forgot" }
          });
        })
        .catch(error => {
          this.error.message = error.response.data.error.message;
        });
    }
  }
};
</script>
